import { useEffect, useRef, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { CHAVE_TOKEN } from "../../../utils/formata";

// ENVIAR PRA GRUPOS (Dani, 19/09: "pega os dados do cliente, localização, lista todos os grupos que temos e manda para os
// grupos selecionados" — com negócio, valor e parcelas). A mesma tela da extensão do Chrome (extensao-grupos/): busca o
// cliente no robô, mostra o texto exato que vai sair, lista os grupos do número da Help e manda pros marcados.
// Dois caminhos pro MESMO robô: no PC dele, direto na porta 127.0.0.1:3456; em qualquer outro lugar (notebook, celular)
// pela ponte do painel (/ponte, functions/ponte) — o robô publica a lista e busca os pedidos a cada 5 s.
const ROBO = "http://127.0.0.1:3456";
const CHAVE_MARCADOS = "help-grupos-marcados";
const cor = { ouro: "#d4af37", ouroClaro: "#e8c95c", verde: "#2ecc71", vermelho: "#ff6b5b", texto: "#f3f4f6", suave: "#a3aec0", fundo: "#0f1e2e", fundoClaro: "#1b2b40", linha: "#24344d" };
const cartao = { background: cor.fundo, border: `1px solid ${cor.linha}`, borderRadius: 12, padding: "14px 16px", minWidth: 0 };
const rotulo = { color: cor.suave, fontSize: "0.72rem", letterSpacing: 0.6, textTransform: "uppercase", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 10 };
const linkBotao = { background: "none", border: 0, color: cor.ouro, fontSize: "0.8rem", padding: "4px 0", cursor: "pointer", whiteSpace: "nowrap", textTransform: "none", letterSpacing: 0 };
const etiqueta = { display: "inline-flex", alignItems: "center", gap: 4, fontSize: "0.72rem", padding: "1px 8px", borderRadius: 99, background: "rgba(212,175,55,.14)", color: cor.ouroClaro, whiteSpace: "nowrap" };
const etiquetaCinza = { ...etiqueta, background: "rgba(163,174,192,.14)", color: cor.suave };
const real = (v) => Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const lerMarcados = () => { try { return JSON.parse(localStorage.getItem(CHAVE_MARCADOS) || "[]"); } catch { return []; } };
const gravarMarcados = (s) => { try { localStorage.setItem(CHAVE_MARCADOS, JSON.stringify([...s])); } catch {} };
const normalizar = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/\s+/g, " ").trim();
const espera = (ms) => new Promise((r) => setTimeout(r, ms));

async function chamar(url, { metodo = "GET", corpo = null, prazo = 15000, cabecalhos = {} } = {}) {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), prazo);
    try {
        const r = await fetch(url, {
            method: metodo,
            headers: { ...cabecalhos, ...(corpo ? { "Content-Type": "application/json" } : {}) },
            body: corpo ? JSON.stringify(corpo) : undefined,
            signal: ctrl.signal,
        });
        const j = await r.json().catch(() => ({ ok: false, mensagem: `resposta inválida (${r.status})` }));
        return { status: r.status, ...j };
    } catch (e) {
        return { ok: false, offline: true, mensagem: e.name === "AbortError" ? "Demorou demais pra responder." : "Sem conexão." };
    } finally {
        clearTimeout(t);
    }
}
const robo = (caminho, op = {}) => chamar(ROBO + caminho, { ...op, cabecalhos: { "X-Help": "1" } });
const ponte = (caminho, op = {}) => {
    let token = "";
    try { token = localStorage.getItem(CHAVE_TOKEN) || ""; } catch {}
    return chamar("/ponte" + caminho, { ...op, cabecalhos: { Authorization: `Bearer ${token}` } });
};
function buscarNaLista(lista, q) {
    const bruto = q.trim();
    const soNumero = /^[\d\s()+.-]+$/.test(bruto) ? bruto.replace(/\D/g, "") : "";
    const termo = soNumero ? "" : normalizar(bruto);
    return lista
        .filter((c) => (soNumero ? `${c.telefone || ""} ${c.ch}`.includes(soNumero.slice(-8)) : !termo || normalizar([c.nome, c.negocio, c.cidade].filter(Boolean).join(" ")).includes(termo)))
        .slice(0, 30);
}
// pela ponte: entrega o pedido e acompanha até o robô devolver (ele busca a cada 5 s)
async function enviarPelaPonte(ch, grupos, documentos) {
    const p = await ponte("/enviar", { metodo: "POST", corpo: { ch, grupos, documentos } });
    if (!p.ok || !p.id) return { ok: false, mensagem: p.mensagem || "Não consegui entregar o pedido ao robô." };
    for (let i = 0; i < 60; i++) {
        await espera(1500);
        const s = await ponte(`/pedido/${p.id}`);
        if (s.status === "feito") return s.resultado || { ok: false, mensagem: "O robô respondeu sem detalhes." };
        if (s.status === "expirado") return { ok: false, mensagem: "O robô do escritório não pegou o pedido a tempo. Nada foi enviado." };
        if (s.status === "sem_confirmacao") return s.resultado || { ok: false, mensagem: "O robô não confirmou. Confira no grupo antes de mandar de novo." };
    }
    return { ok: false, mensagem: "Sem resposta do robô em 90 s. Confira no grupo antes de mandar de novo." };
}

export default function EnviarGrupos() {
    const [params] = useSearchParams();
    const inicial = (params.get("grupos") || "").trim();
    const [modo, setModo] = useState(null); // "local" (PC do robô) | "nuvem" (qualquer outro lugar)
    const [status, setStatus] = useState({ carregando: true, conectado: false, texto: "procurando o robô…" });
    const [busca, setBusca] = useState(inicial);
    const [clientes, setClientes] = useState({ carregando: true, lista: [], erro: "" });
    const [cliente, setCliente] = useState(null);
    const [grupos, setGrupos] = useState({ carregando: true, lista: [], erro: "" });
    const [marcados, setMarcados] = useState(() => new Set(lerMarcados()));
    const [confirmando, setConfirmando] = useState(false);
    const [enviando, setEnviando] = useState(false);
    const [resultado, setResultado] = useState(null);
    const [docs, setDocs] = useState(new Set()); // documentos marcados pra ir junto (Dani, 20/09)
    const listaNuvem = useRef([]);
    const timerConfirma = useRef(null);
    const buscaAtual = useRef(0);
    const escolheuSozinho = useRef(false);

    const aplicarGrupos = useCallback((lista, erro = "") => {
        const ids = new Set(lista.map((g) => g.id));
        setMarcados((m) => { const n = new Set([...m].filter((id) => ids.has(id))); gravarMarcados(n); return n; });
        setGrupos({ carregando: false, lista, erro });
    }, []);

    const carregarGrupos = useCallback(async (qual, forcar = false) => {
        setGrupos((g) => ({ ...g, carregando: true, erro: "" }));
        if (qual === "nuvem") {
            const r = await ponte("/estado");
            if (!r.ok) {
                setStatus({ carregando: false, conectado: false, texto: r.status === 401 ? "faça login de novo no painel" : r.status === 403 ? "só o login da dona" : "painel sem resposta" });
                return setGrupos({ carregando: false, lista: [], erro: r.mensagem || "Não consegui falar com o robô pela nuvem." });
            }
            listaNuvem.current = r.clientes || [];
            setStatus({ carregando: false, conectado: !!r.conectado, texto: r.conectado ? "robô conectado (pela nuvem)" : "robô do escritório desligado" });
            aplicarGrupos(r.grupos || [], r.conectado ? "" : "O robô do escritório está desligado ou sem WhatsApp: nada é enviado até ele voltar.");
            return;
        }
        const r = await robo(`/grupos${forcar ? "?forcar=1" : ""}`, { prazo: 20000 });
        if (!r.ok) return setGrupos({ carregando: false, lista: [], erro: r.mensagem || "Não consegui listar os grupos." });
        aplicarGrupos(r.grupos);
    }, [aplicarGrupos]);

    const conferirRobo = useCallback(async (qual) => {
        if (qual === "nuvem") return carregarGrupos("nuvem");
        const r = await robo("/saude", { prazo: 5000 });
        const conectado = !!(r.ok && r.conectado);
        setStatus({ carregando: false, conectado, texto: conectado ? "robô conectado" : r.ok ? "robô sem WhatsApp" : "robô fora do ar" });
    }, [carregarGrupos]);

    useEffect(() => {
        let vigia = null;
        (async () => {
            // no PC do robô a porta local responde; em qualquer outro lugar, vai pela ponte do painel
            const saude = await robo("/saude", { prazo: 1500 });
            const qual = saude.ok ? "local" : "nuvem";
            setModo(qual);
            if (qual === "local") {
                setStatus({ carregando: false, conectado: !!saude.conectado, texto: saude.conectado ? "robô conectado" : "robô sem WhatsApp" });
                if (saude.conectado) carregarGrupos("local");
                else setGrupos({ carregando: false, lista: [], erro: "Ligue o WhatsApp do robô para ver os grupos." });
            } else {
                await carregarGrupos("nuvem");
            }
            vigia = setInterval(() => conferirRobo(qual), qual === "nuvem" ? 60000 : 30000);
        })();
        return () => clearInterval(vigia);
    }, [conferirRobo, carregarGrupos]);

    useEffect(() => {
        if (!modo) return;
        const n = ++buscaAtual.current;
        const t = setTimeout(async () => {
            const r = modo === "local" ? await robo(`/clientes?q=${encodeURIComponent(busca.trim())}`) : { ok: true, clientes: buscarNaLista(listaNuvem.current, busca) };
            if (n !== buscaAtual.current) return;
            if (!r.ok) return setClientes({ carregando: false, lista: [], erro: r.offline ? "Não achei o robô." : r.mensagem || "Não consegui buscar." });
            setClientes({ carregando: false, lista: r.clientes, erro: "" });
            // veio do cadastro do cliente (?grupos=telefone) e só ele bate: já abre escolhido
            if (inicial && !escolheuSozinho.current && busca.trim() === inicial && r.clientes.length === 1) {
                escolheuSozinho.current = true;
                setCliente(r.clientes[0]);
            }
        }, modo === "local" ? 250 : 0);
        return () => clearTimeout(t);
    }, [busca, inicial, modo, grupos.lista]);

    useEffect(() => () => clearTimeout(timerConfirma.current), []);

    const desarmar = () => { clearTimeout(timerConfirma.current); setConfirmando(false); };
    const alternar = (id) => {
        desarmar();
        setMarcados((m) => { const n = new Set(m); if (n.has(id)) n.delete(id); else n.add(id); gravarMarcados(n); return n; });
    };
    const escolher = (c) => { desarmar(); setResultado(null); setDocs(new Set()); setCliente(c); };

    async function enviar() {
        if (!cliente || !marcados.size || enviando) return;
        // 1º clique arma, 2º confirma (6 s): dado de cliente em grupo errado não tem volta
        if (!confirmando) {
            setConfirmando(true);
            timerConfirma.current = setTimeout(() => setConfirmando(false), 6000);
            return;
        }
        desarmar();
        setEnviando(true);
        const r = modo === "local"
            ? await robo("/grupos/enviar", { metodo: "POST", corpo: { ch: cliente.ch, grupos: [...marcados], documentos: [...docs] }, prazo: 120000 })
            : await enviarPelaPonte(cliente.ch, [...marcados], [...docs]);
        setEnviando(false);
        setResultado(r);
    }

    const carregarGruposAgora = (forcar) => carregarGrupos(modo, forcar);
    const n = marcados.size;
    const textoBotao = enviando ? (modo === "nuvem" ? "Enviando pelo robô do escritório…" : "Enviando…") : !cliente ? "Escolha o cliente" : !n ? "Marque pelo menos um grupo" : n > 15 ? "No máximo 15 grupos por vez"
        : `${confirmando ? "Confirmar: enviar" : "Enviar"} para ${n} grupo${n === 1 ? "" : "s"}`;
    const podeEnviar = !!cliente && n > 0 && n <= 15 && !enviando;


    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
                <div style={{ color: cor.suave, fontSize: "0.88rem", maxWidth: 640 }}>
                    Escolha o cliente, confira o texto e marque os grupos. Vai nome, negócio, cidade, valor e a localização (com o pino do mapa).
                    {modo === "nuvem" && <div style={{ marginTop: 4, fontSize: "0.8rem" }}>Fora do computador do robô: o pedido vai pela nuvem do painel e o robô do escritório envia em poucos segundos.</div>}
                </div>
                <div role="status" style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.82rem", color: cor.suave, whiteSpace: "nowrap" }}>
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: status.carregando ? cor.suave : status.conectado ? cor.verde : cor.vermelho, boxShadow: status.carregando ? "none" : `0 0 8px ${status.conectado ? cor.verde : cor.vermelho}` }}></span>
                    {status.texto}
                </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 340px), 1fr))", gap: 14, alignItems: "start" }}>
                <section style={cartao} aria-labelledby="grupos-cliente">
                    <div style={rotulo}>
                        <label id="grupos-cliente" htmlFor="grupos-busca" style={{ margin: 0 }}>1. Cliente</label>
                        {cliente && <button type="button" style={linkBotao} onClick={() => { desarmar(); setResultado(null); setCliente(null); }}>trocar cliente</button>}
                    </div>
                    {!cliente ? (
                        <>
                            <input id="grupos-busca" type="search" className="form-control" autoComplete="off" value={busca} onChange={(e) => setBusca(e.target.value)}
                                placeholder="Nome, cidade ou telefone" style={{ fontSize: 16 }} />
                            <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 10, maxHeight: 360, overflowY: "auto" }}>
                                {clientes.carregando ? <div style={{ color: cor.suave, fontSize: "0.85rem" }}>buscando…</div>
                                    : clientes.erro ? <div style={{ color: cor.vermelho, fontSize: "0.85rem" }}>{clientes.erro}</div>
                                    : !clientes.lista.length ? <div style={{ color: cor.suave, fontSize: "0.85rem" }}>{busca.trim() ? "Ninguém com esse nome, cidade ou telefone." : "Nenhum cliente com dados ainda."}</div>
                                    : clientes.lista.map((c) => (
                                        <button key={c.ch} type="button" onClick={() => escolher(c)}
                                            style={{ textAlign: "left", width: "100%", background: cor.fundoClaro, border: "1px solid transparent", borderRadius: 10, padding: "10px 12px", color: cor.texto, cursor: "pointer" }}>
                                            <div style={{ fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {c.nome || c.negocio || "Cliente sem nome"}{c.nome && c.negocio ? <span style={{ color: cor.suave, fontWeight: 400 }}> — {c.negocio}</span> : null}
                                            </div>
                                            <div style={{ color: cor.suave, fontSize: "0.8rem", display: "flex", gap: 8, flexWrap: "wrap", marginTop: 2 }}>
                                                {c.cidade && <span>{c.cidade}</span>}
                                                {c.valor ? <span>{real(c.valor)}{c.parcelas ? ` · ${c.parcelas}x` : ""}</span> : null}
                                                {c.localizacao ? <span style={etiqueta}><i className="bi bi-geo-alt-fill"></i> localização</span>
                                                    : <span style={etiquetaCinza}>{c.endereco ? "endereço" : "sem localização"}</span>}
                                            </div>
                                        </button>
                                    ))}
                            </div>
                        </>
                    ) : (
                        <>
                            <div data-previa style={{ whiteSpace: "pre-wrap", background: "#0b2a22", border: "1px solid #1f4d3f", borderRadius: 10, padding: "10px 12px", fontSize: "0.9rem", overflowWrap: "anywhere", color: cor.texto }}>{cliente.recado}</div>
                            <div style={{ color: cor.suave, fontSize: "0.8rem", marginTop: 6 }}>
                                {cliente.localizacao ? "Vai este texto e, logo abaixo, o pino da localização (abre no mapa)." : "Este cliente ainda não mandou a localização pelo WhatsApp: vai só o texto."}
                            </div>
                            {/* DOCUMENTOS (Dani, 20/09: "publicar os documentos também") — o arquivo fica no PC do robô */}
                            {!!(cliente.documentos || []).length && (
                                <div style={{ marginTop: 12 }}>
                                    <div style={rotulo}><span>Documentos desta pessoa ({cliente.documentos.length})</span></div>
                                    {cliente.documentos.map((doc) => (
                                        <label key={doc.chave} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 6px", borderRadius: 8, cursor: "pointer", margin: 0 }}>
                                            <input type="checkbox" checked={docs.has(doc.chave)} style={{ width: 20, height: 20, accentColor: cor.ouro, flex: "none" }}
                                                onChange={() => { desarmar(); setDocs((s) => { const n = new Set(s); if (n.has(doc.chave)) n.delete(doc.chave); else n.add(doc.chave); return n; }); }} />
                                            <span style={{ flex: 1, minWidth: 0 }}>
                                                <span style={{ display: "block", color: cor.texto }}>{doc.pdf ? "PDF" : "Foto"} · {new Date(doc.quando).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</span>
                                                <span style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6, marginTop: 2 }}>
                                                    <span style={doc.lido ? etiqueta : etiquetaCinza}>{doc.lido ? "documento lido" : "arquivo recebido"}</span>
                                                    <span style={{ color: cor.suave, fontSize: "0.76rem" }}>{Math.max(1, Math.round(doc.tamanho / 1024))} KB</span>
                                                </span>
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                    {resultado && (
                        <div role="status" style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 4, fontSize: "0.86rem" }}>
                            <div style={{ fontWeight: 700, color: resultado.ok ? cor.verde : cor.vermelho }}>{resultado.mensagem || (resultado.ok ? "Enviado." : "Não consegui enviar.")}</div>
                            {(resultado.resultados || []).map((x) => (
                                <div key={x.id} style={{ color: x.ok ? cor.verde : cor.vermelho, display: "flex", gap: 6, alignItems: "center" }}>
                                    <i className={`bi ${x.ok ? "bi-check-circle-fill" : "bi-x-circle-fill"}`}></i>
                                    <span>{x.nome}{x.ok ? "" : " (não saiu)"}{x.documentos ? ` · ${x.documentos} documento${x.documentos === 1 ? "" : "s"}` : ""}{x.ok && cliente?.localizacao && !x.pino ? " (sem o pino — o link do mapa foi)" : ""}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </section>

                <section style={cartao} aria-labelledby="grupos-titulo">
                    <div style={rotulo}>
                        <span id="grupos-titulo">2. Grupos{n ? ` · ${n} marcado${n === 1 ? "" : "s"}` : ""}</span>
                        <button type="button" style={linkBotao} onClick={() => carregarGruposAgora(true)} disabled={grupos.carregando}>atualizar lista</button>
                    </div>
                    {grupos.carregando ? <div style={{ color: cor.suave, fontSize: "0.85rem" }}>carregando os grupos…</div>
                        : grupos.erro ? <div style={{ color: cor.vermelho, fontSize: "0.85rem" }}>{grupos.erro}</div>
                        : !grupos.lista.length ? <div style={{ color: cor.suave, fontSize: "0.85rem" }}>O número da Help não está em nenhum grupo.</div>
                        : grupos.lista.map((g) => (
                            <label key={g.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 6px", borderRadius: 8, cursor: "pointer", margin: 0 }}>
                                <input type="checkbox" checked={marcados.has(g.id)} onChange={() => alternar(g.id)} style={{ width: 20, height: 20, accentColor: cor.ouro, flex: "none" }} />
                                <span style={{ flex: 1, minWidth: 0 }}>
                                    <span style={{ display: "block", color: cor.texto, overflowWrap: "anywhere" }}>{g.nome}</span>
                                    <span style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6, marginTop: 2 }}>
                                        {g.papel && <span style={etiqueta}>{g.papel}</span>}
                                        <span style={{ color: cor.suave, fontSize: "0.76rem", whiteSpace: "nowrap" }}>{g.participantes} pessoa{g.participantes === 1 ? "" : "s"}</span>
                                    </span>
                                </span>
                            </label>
                        ))}
                </section>
            </div>

            <button type="button" className={`btn ${confirmando ? "btn-success" : "btn-he"}`} disabled={!podeEnviar} onClick={enviar}
                style={{ width: "100%", maxWidth: 520, alignSelf: "center", padding: "12px 16px", fontWeight: 800, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {enviando ? <span className="spinner-border spinner-border-sm" style={{ marginRight: 8 }}></span> : <i className="bi bi-send-fill" style={{ marginRight: 8 }}></i>}
                {textoBotao}
            </button>
        </div>
    );
}
